import api from "../api/axiosConfig";

export interface ClaimQueueItemResponse {
  success?: boolean;
  message?: string;
  data?: any;
  queueItem?: any;
  item?: any;
  [key: string]: any;
}

export const claimTeleQueueItem = async (
  queueId: string,
  queueItemId: string,
  doctorId: string,
  doctorName: string
): Promise<ClaimQueueItemResponse> => {
  const response = await api.CenterworkflowApi.post(
    `/queues/${queueId}/items/${queueItemId}/claim`,
    {
      doctorId,
      doctorName,
    }
  );

  return response.data;
};